const state = {
  actions: [{
    label: '',
    model: ''
  }]
}

const mutations = {
  addAction (state, payload) {
    state.actions.push({ label: payload.name.concat('(', payload.type, ')'), model: payload.name })
  },

  clear (state) {
    state.actions = []
  },

  remove (state, payload) {
    state.actions.forEach((el, i) => {
      if (el.model === payload.actionName) {
        state.actions.splice(i, 1)
      }
    })
  }
}

export default {
  state,
  mutations
}
